import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-content-heading',
  templateUrl: './content-heading.component.html',
  styleUrls: ['./content-heading.component.sass']
})
export class ContentHeadingComponent implements OnInit {

  @Input() title: string;
  @Input() registerPage = false;
  @Input() icon: any;
  @Input() hasBreadcrumbs = true;

  constructor() { }

  ngOnInit(): void {

  }

}
